"use client";

import { useCurrencyFormatter } from "~/lib/use-currency";

import type { DatoTripHotel } from "../_lib/trip-context";

export function CartItineraryAccommodation({
  amount,
  hotel,
}: {
  amount: number;
  hotel: DatoTripHotel | null;
}) {
  const formatCurrency = useCurrencyFormatter();
  const formattedAmount = amount ? formatCurrency(amount) : null;
  return (
    <div className="line-clamp-1">
      {hotel?.name}
      {amount > 0 ? <> - {formattedAmount} upgrade</> : null}
    </div>
  );
}
